<div class="relative text-left flex items-center">
    <span nz-dropdown [nzDropdownMenu]="menu">
        <p class="text-[13px] leading-5 text-gray-100 font-medium pr-2 hidden lg:inline-block">
            {{ userLogged?.name }}
            {{ userLogged?.surname }}
        </p>
        
        <nz-avatar [nzText]="userAbbreviation" style="background-color:#4edeb5;"></nz-avatar>
    </span>

    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item [routerLink]="['/change-password']">
                Cambiar contraseña</li>

            @if (showOption('configurations')) {
            <li nz-menu-item [routerLink]="['/configuration']">
                Configuración</li>
            }

            <li nz-menu-item [routerLink]="['/permissions']">
                Permisos</li>
            

            <li nz-menu-item (click)="logout()">
                Cerrar sesión</li>

            <li nz-menu-divider></li>

            <li nz-menu-item nzDisabled class="text-[12px] leading-5 text-gray-500 truncate font-light">
                {{ bottomText }}
            </li>
        </ul>
    </nz-dropdown-menu>
</div>